import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { NotificationContext } from '@client/context/NotificationContext';
import { useDirty } from '@client/store/dirty.store';
import { successSaveMsg } from '@client/utils/message.util';

import type { IFeature, IObjectId } from '@common/types';
import type { FormInstance } from 'antd';

type TFinishProps = {
  formRef: FormInstance<IFeature>;
  isEdit: boolean;
  entity: string;
};

export const useOnFinish = (props: TFinishProps) => {
  const { formRef, isEdit, entity } = props;

  const { messageApi } = useContext(NotificationContext);
  const { isDirty, setDirty } = useDirty();
  const navigate = useNavigate();

  const [success, setSuccess] = useState(false);

  const onSuccess = async <T extends IObjectId>(
    navigateTo: T['id'],
    redirect?: boolean,
  ) => {
    setDirty(false);
    setSuccess(true);
    await successSaveMsg(messageApi, isEdit, entity);

    if (redirect) navigate(navigateTo);
  };

  useEffect(() => {
    if (success && !isEdit && !isDirty) {
      formRef.resetFields();
    }
  }, [formRef, isEdit, success, isDirty]);

  return { onSuccess };
};
